import { getCookie } from 'cookies-next/client'

import { COOKIE_EXPA_NAME } from '../cookies'

export const expaGetClientSideExpaFromCookie = (): string | undefined => {
  return getCookie(COOKIE_EXPA_NAME)
}
